import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const prevPathWithoutLang = useRef(null);

  // Extract path without language prefix (e.g., /en/about -> /about)
  const getPathWithoutLang = (path) => {
    const parts = path.split('/').filter(Boolean);
    if (parts.length > 0 && ['en', 'bm', 'zh'].includes(parts[0])) {
      return '/' + parts.slice(1).join('/');
    }
    return path;
  };

  useEffect(() => {
    const currentPathWithoutLang = getPathWithoutLang(pathname);
    
    // Scroll to top if:
    // 1. No hash (anchor link)
    // 2. Either initial load OR the path without language actually changed (not just language switch)
    if (!hash && (
        prevPathWithoutLang.current === null || 
        prevPathWithoutLang.current !== currentPathWithoutLang
      )) {
      window.scrollTo(0, 0);
    }
    
    // Update previous path
    prevPathWithoutLang.current = currentPathWithoutLang;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;